import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { getCreateSupportTicketModalAction } from '../utils/createSupportTicketModal';

/** Opens the Create Support Ticket modal via the global modal system. */
export function useOpenCreateSupportTicketModal() {
  const dispatch = useDispatch();
  return useCallback(() => {
    dispatch(getCreateSupportTicketModalAction());
  }, [dispatch]);
}
